import {Component, Input, OnInit} from '@angular/core';
import {TruckModel} from '../../models/truckModel';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-truck-select',
  templateUrl: './truck-select.component.html',
  styleUrls: ['./truck-select.component.scss']
})
export class TruckSelectComponent implements OnInit {

  @Input() truckFormGroup?: FormGroup;

  @Input() truckModelsList?: TruckModel[];


  constructor() {}

  ngOnInit(): void {
  }

  setTruckModel(truckModel: TruckModel): void {
    this.setField('eGrossWeight', truckModel.eGrossWeight);
    this.setField('eTare', truckModel.eTare);
    this.setField('battery', truckModel.battery);
    this.setField('chargingTime', truckModel.chargingTime);
  }

  setField(fieldName: string, fieldValue?: number): void {
    if (fieldValue) {
      this.truckFormGroup?.get(fieldName)?.setValue(fieldValue);
    }
  }

  // Preserve original property order
  originalOrder = (a: any, b: any): number => {
    return 0;
  }

}
